// Helper to support both CRA and Vite environments during migration
const getEnv = (key: string): string | undefined => {
  // Try Vite format first (import.meta.env.VITE_APP_*)
  const viteKey = key.replace('REACT_APP_', 'VITE_APP_');
  // @ts-ignore
  if (typeof window !== 'undefined' && import.meta?.env?.[viteKey]) {
    // @ts-ignore
    return import.meta.env[viteKey];
  }

  // Also try original REACT_APP_ in Vite (Vite loads all env vars)
  // @ts-ignore
  if (typeof window !== 'undefined' && import.meta?.env?.[key]) {
    // @ts-ignore
    return import.meta.env[key];
  }

  // Fallback to CRA format (process.env.REACT_APP_*)
  if (typeof process !== 'undefined' && process.env?.[key]) {
    return process.env[key];
  }

  return undefined;
};

export const environmentVariables = {
    awsDataRoot: () => getEnv('REACT_APP_AWS_ROOT'),
    websocketRoot: () => getEnv('REACT_APP_WEBSOCKET_ROOT'),
    websocketAuthToken: () => getEnv('REACT_APP_WEBSOCKET_AUTH_TOKEN'),
    contentProxyRoot: () => getEnv('REACT_APP_CONTENT_PROXY_ROOT'),
    contentProxyUsername: () => getEnv('REACT_APP_CONTENT_PROXY_USERNAME'),
    contentProxyPassword: () => getEnv('REACT_APP_CONTENT_PROXY_PASSWORD'),
    googleAnalyticsMeasurementId: () => getEnv('REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID'),
    slackBotToken: () => getEnv('REACT_APP_SLACK_BOT_TOKEN'),
    googleCredentials: () => getEnv('REACT_APP_GOOGLE_CREDENTIALS'),
    userPermissions: () => getEnv('REACT_APP_PERMISSIONS'),
    appEnv: () => getEnv('REACT_APP_ENV'),
    contentfulEnv: () => getEnv('REACT_APP_CONTENT_PROXY_ENV'),
    specialVersion: () => getEnv('REACT_APP_SPECIAL_VERSION'),
    userServiceBaseApiUrl: () => getEnv('REACT_APP_USER_SERVICE_BASE_API_URL'),
    contentDockContext: () => getEnv('REACT_APP_CONTENT_DOCK_CONTEXT'),
    sendNotification: () => getEnv('REACT_APP_SEND_NOTIFICATION'),
    applicationName: () => getEnv('REACT_APP_APPLICATION_NAME'),
    loginUrl: () => getEnv('REACT_APP_LOGIN_URL'),
    updateProfile: () => getEnv('REACT_APP_UPDATE_PROFILE'),
    resetPasswordUrl: () => getEnv('REACT_APP_RESET_PASSWORD_URL'),
    logoutUrl: () => getEnv('REACT_APP_LOGOUT_URL'),
    deleteUser: () => getEnv('REACT_APP_DELETE_USER'),
    registerUrl: () => getEnv('REACT_APP_REGISTER_URL'),
    newPasswordUrl: () => getEnv('REACT_APP_NEW_PASSWORD_URL'),
    forgotPasswordNotification: () => getEnv('REACT_APP_FORGOT_PASSWORD_NOTIFICATION'),
    sailgpResultsUrl: () => getEnv('REACT_APP_SAILGP_RESULTS_URL'),
};
